import { render, staticRenderFns } from "./ProductAttributes.vue?vue&type=template&id=12c66646&scoped=true&"
import script from "./ProductAttributes.vue?vue&type=script&lang=js&"
export * from "./ProductAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributes.vue?vue&type=style&index=0&id=12c66646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c66646",
  null
  
)

export default component.exports